<template>
  <div class="pro-detail">
    <Card>
      <Tabs value="name1" style="width: 70%;margin:0 auto">
        <TabPane label="详细信息" name="name1">
          <div class="form">
            <Row class="table-col">
              <Col :span="24" class="table-item">
                <span class="label">专家姓名</span>
                <div class="value">
                  {{ proInfo.specialist.name }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="12" class="table-item">
                <span class="label">性别</span>
                <div class="value">
                  {{ proInfo.specialist.sex }}
                </div>
              </Col>
              <Col :span="12" class="table-item">
                <span class="label">身份证号</span>
                <div class="value">
                  {{ proInfo.specialist.idCard }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="12" class="table-item">
                <span class="label">手机</span>
                <div class="value">
                  {{ proInfo.specialist.phone }}
                </div>
              </Col>
              <Col :span="12" class="table-item">
                <span class="label">专家级别</span>
                <div class="value">
                  {{ proInfo.specialist.specialistLevel }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="12" class="table-item">
                <span class="label">最高学历</span>
                <div class="value">
                  {{ proInfo.specialist.highestDegree }}
                </div>
              </Col>
              <Col :span="12" class="table-item">
                <span class="label">行政区域</span>
                <div class="value">
                  {{ proInfo.specialist.responsibleAreaId }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="24" class="table-item">
                <span class="label">住址</span>
                <div class="value">
                  {{ proInfo.specialist.name }}
                </div>
              </Col>
            </Row>
<!--            <Row class="table-col">-->
<!--              <Col :span="12" class="table-item">-->
<!--                <span class="label">经度</span>-->
<!--                <div class="value">-->
<!--                </div>-->
<!--              </Col>-->
<!--              <Col :span="12" class="table-item">-->
<!--                <span class="label">纬度</span>-->
<!--                <div class="value">-->
<!--                </div>-->
<!--              </Col>-->
<!--            </Row>-->
            <Row class="table-col">
              <Col :span="12" class="table-item">
                <span class="label">工作单位</span>
                <div class="value">
                  {{ proInfo.specialist.workUnit }}
                </div>
              </Col>
              <Col :span="12" class="table-item">
                <span class="label">事件类型</span>
                <div class="value">
                  {{ proInfo.specialist.applicableEventTypes }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="24" class="table-item">
                <span class="label">备注</span>
                <div class="value">
                  {{ proInfo.specialist.remark }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="24" class="table-item">
                <span class="label">附件</span>
                <div class="value">
                  {{ proInfo.specialist.annex }}
                </div>
              </Col>
            </Row>
            <Row class="table-col">
              <Col :span="24" class="table-item">
                <span class="label">照片</span>
                <div class="value">
                  {{ proInfo.specialist.picture }}
                </div>
              </Col>
            </Row>
          </div>
        </TabPane>
        <TabPane label="历史维护记录" name="name2">
          <Table
              :loading="dataLoading"
              :columns="columns"
              :data="data"
              :border="false"
              :stripe="false"
              :highlight-current-row="true"
          >
            <!--            <template #action="{ row, index }">-->
            <!--              <Button size="small" type="text" disabled >定位</Button>-->
            <!--              <Button size="small" type="text" @click="gotoDetail(row)">查看</Button>-->
            <!--              <Button size="small" type="text" disabled >历史</Button>-->
            <!--              <Button size="small" type="text" disabled >调派</Button>-->
            <!--              <Button size="small" type="text" @click="editTeam(row)">编辑</Button>-->
            <!--              <Button size="small" type="text" disabled >删除</Button>-->
            <!--            </template>-->
          </Table>
          <Page style="text-align: right;margin-top: 10px"
                show-sizer
                show-total
                transfer
                :total="dataTotal"
                :page-size="pageSize"
                :page-size-opts="pageSizeOpts"
                :current-page="currentPage"
                @on-change="pageChange"
                @on-page-size-change="pageSizeChange"
          ></Page>
        </TabPane>
      </Tabs>

    </Card>
  </div>
</template>

<script>
export default {
  name: "emProfressorDetail",
  data() {
    return {
      proInfo: {
        name: '',
        idCard: '',
        personInCharge: '',
        personInChargePhone: '',
        phone: '',
        professionType: '',
        specialistLevel: 1,//1国家级专家2省级专家3市级专家4县区级专家
        sex: '',
        highestDegree: '',
        establishedTime: '',
        responsibleAreaId: '',
        responsibleStreetId: '',
        address: '',
        longitude: '',
        dimension: '',
        workUnit: '',
        applicableEventTypes: 1,
        superviseLevel: 1,//1-市级，2-区县级，3-镇街级
        introduce: '',
        remarks: '',
        annex: '',
        picture: ''
      },
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '维护时间',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.name)
          }
        },
        {
          title: '维护人单位',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.personInCharge)
          },
        },
        {
          title: '维护人姓名',
          align: 'center',
          // width: '130',
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'left'
              }
            }, params.row.emergencyTeam.personInChargePhone)
          },
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  mounted() {
    if (this.$route.params.row) {
      this.proInfo = this.$route.params.row
    }
  },
  methods: {
    pageChange(page) {
      this.currentPage = page
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
    },
  }
}
</script>

<style scoped lang="less">
.pro-detail {

  .form {
    border: solid 1px #dcdee2;

    .table-col:not(:last-child) {
      border-bottom: solid 1px #dcdee2;
    }

    .table-item:not(:last-child) {
      border-right: solid 1px #dcdee2;
    }

    .table-col {
      height: 100%;
      display: flex;
    }

    .table-item {
      height: 100%;
      display: flex;

      > div {
        display: flex;
      }

      .label {
        display: flex;
        align-items: end;
        width: 160px;
        text-align: right;
        background: #f8f8f9;
        color: #666;
        padding: 8px 12px;
        justify-content: end;
        border-right: solid 1px #dcdee2;
        //font-weight: bolder;
        font-size: 14px;
      }

      .value {
        display: flex;
        align-items: start;
        word-wrap: break-word;
        color: #222;
        font-size: 14px;
        padding: 8px 12px;
        flex: 1;
        justify-content: start;
      }

      .optionValue {
        flex-direction: column;

        .ivu-timeline-item {
          padding: 0;
        }
      }
    }
  }
}
</style>
